import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { ResourceData } from '../../../elements/resource/resource.types';
import { ShapeService } from '../../../element-editor/shape/shape.service';
import { IdToIRI, IRIToId } from '../../../util/iri';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCurrentFileID } from '../../../projects/project.selector';
import { map } from 'rxjs/operators';
import { ProjectService } from '../../../projects/project.service';
import { deleteScene } from '../../../projects/project.actions';
import { CanvasService } from '../../../services/canvas/canvas.service';
import { setCurrentAnimationId } from '../../../element-editor/animation/store/animation.actions';
import { setResourceLabel } from '../../../element-editor/store/editor.actions';
@Component({
  selector: 'nw-slide-item',
  templateUrl: './slide-item.component.html',
  styleUrls: ['./slide-item.component.scss'],
})
export class SlideItemComponent implements OnInit {
  @Input() slide: ResourceData;
  @Input() index: number;
  @Input() newSceneMode = false;
  @Output() select = new EventEmitter<void>();

  get isSelected() {
    return this.cs.currentFileID === IRIToId(this.slide.IRI);
  }
  imgLoaded: boolean;
  imgError: boolean;
  selected$: Observable<boolean>;
  constructor(
    private readonly shapeService: ShapeService,
    private readonly store: Store,
    private readonly projectService: ProjectService,
    private readonly cs: CanvasService,
    private cdr: ChangeDetectorRef,
  ) {
    this.cs.generalEventSubscribe('thumbnail-updated', IRI => {
      // -- // -- //
      /* console.log('slide-item > thumbnail-updated', {
        IRI,
        slide: this.slide?.IRI,
      }); */
      if (IRI === this.slide?.IRI) {
        console.log('cdr-detectChanges');
        this.cdr.detectChanges();
      }
    });
  }

  getThumbnailDataUrl() {
    // -- // -- // -- //
    // if (
    //   this.cs.currentFileID === IRIToId(this.slide.IRI)
    //   // &&
    //   // this.cs.thumbnailUpdated
    // ) {
    //   return this.cs.thumbnailDataUrl;
    // }
    // -- // -- // -- //

    return this.cs.thumbnailsByFile[this.slide.IRI];
    // `https://s3.eu-central-1.amazonaws.com/nowords-vlog.illustrations/${id}_thumbnail.png`
  }
  click() {
    if (this.slide) {
      this.store.dispatch(setCurrentAnimationId({ id: null }));
      if (this.slide.IRI === IdToIRI(this.cs.currentFileID)) {
        this.cs.previewShape.resetBaseState();
        return;
      }

      this.shapeService.navigateToFile(IRIToId(this.slide.IRI));
    } else {
      this.projectService.addSceneAfter();
    }
  }

  updateLabel(label: string) {
    this.store.dispatch(setResourceLabel({ IRI: this.slide.IRI, label }));
  }

  ngOnInit(): void {
    if (!this.slide) {
      return;
    }
    // console.log('slide-item > ngOnInit', this.slide.IRI);
    this.selected$ = this.store
      .select(selectCurrentFileID)
      .pipe(map(id => id === IRIToId(this.slide.IRI)));
  }

  onDelete() {
    this.store.dispatch(deleteScene({ IRI: this.slide.IRI }));
  }

  onSelect() {
    this.select.emit();
  }

  showDelete = false;
  on = false;
  onMouseOver() {
    setTimeout(() => {
      if (!this.on) {
        return;
      }
      this.showDelete = true;
    }, 1_500);
  }
  onMouseOut() {
    this.showDelete = false;
    this.on = false;
  }
}
